import React from 'react';

import OptimizedImage from '../OptimizedImage';

import CompanyDetails from './aboutUsPartials/CompanyDetails';
import Foundation from './aboutUsPartials/Foundation';

const AboutUsCulture = () => {
  return (
    <div className="container">
      <div className="company-presentation">
        <CompanyDetails />
        <OptimizedImage
          src="pages/about-us/culture_photo.png"
          className="mg-fluid main-img"
          alt="culture banner"
          title="culture banner"
        />
        <Foundation />
      </div>
    </div>
  );
};

export default AboutUsCulture;
